import Pusher from 'pusher-js';
import { getSavedState } from '@/helpers/storageOperations';

export default class PusherRepo {
    constructor(appKey, { channelAuthorization, ...options } = {}) {
        const accessToken = getSavedState('auth.accessToken');
        const csrfToken = getSavedState('auth.csrfToken');

        const { params, ...restChannelOptions } = channelAuthorization;
        const { headers, ...restParams } = params;

        this.socket = new Pusher(appKey, {
            ...options,
            channelAuthorization: {
                ...restChannelOptions,
                params: {
                    ...restParams,
                },
                headers: {
                    ['X-CSRF-TOKEN']: csrfToken,
                    Authorization: `Bearer ${accessToken}`,
                    ...headers
                }
            }
        });
    }

    subscribe(name, options = {}) {
        let channel = this.socket.subscribe(name, options);
        return channel;
    }

    unsubscribe(name) {
        this.socket.unsubscribe(name);
    }

    disconnect() {
        this.socket.disconnect();
    }
}
